export const emailJsInfo = {
    service_id: "service_st0qe55",
    template_id: "template_c1f7n49",
    public_key: "rO7tJ3s1smQ3YT5Vb"
}